<template>
  <CustomModal ref="modal" title="Ajout d'un professionnel">
    <p>Afin d'ajouter un professionnel, il faut lui demander son jeton.</p>
    <p>Pour obtenir ce jeton, le professionnel doit se rendre dans les paramètres du groupe, section Gestionnaire - Devis & Factures, cliquer sur Ajouter un comptable, puis générer le jeton et vous le transmettre.</p>
    <div>
    <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
        <CustomTextField :content=inputs.userToken />
        <CustomButton @click="submitForm" :params=buttons.submit style="margin-top: 30px" />
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import {NotificationService} from "@vues/v-common";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import {GroupController} from "@/controllers/user/GroupController";
library.add(faXmark);

  export default {
      name: 'AddProfessionalModal',
      props: ['callback'],
      components: {CustomModal, CustomForm, CustomTextField, CustomButton},
      data() {
          return {
            inputs: {
              userToken: {label: 'Jeton', value: '', type: 'text'}
            },
            buttons:{
              submit: {text: "Ajouter"},
            }
          };
      },
      methods: {
        openModal() {
          this.$refs.modal.openModal();
          this.inputs.userToken.value = '';
        },
        closeModal(event = false) {
          this.$refs.modal?.closeModal(event);
        },
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => GroupController.linkAccountantToGroup(
              this.inputs.userToken.value
          ));
          if (!res.errors) {
            (new NotificationService).addNotification("success","Professionnel jumelé.");
            this.closeModal(true);
            this.callback();
          }
        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';
    .modal
      padding-bottom 40px
      height auto
    .button-container
      display flex
      justify-content center
      padding-top 20px
</style>
